import MailTo from 'components/mailTo/mailTo'
import { Trans, useTranslation } from 'react-i18next'
import { Theme, makeStyles } from '@material-ui/core'
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
    mailTo: {
        fontWeight: 500,
        fontFamily: theme.typography.fontFamily,
        marginRight: 25,
        lineHeight: 14
    }
}))

const Footer = () => {
    const { t } = useTranslation('common')
    const { mailTo } = useStyles()

    return (
        <footer className="footer">
            <div className="footer__logoContainer">
                <div className="footer__logo" />
            </div>
            <div className="footer__linkContainer">
                <MailTo
                    email="support@genomate.health"
                    subject={t('contact.subject')}
                    body={t('contact.body')}
                    ctaI18nKey="common:contact.ctaText"
                    typographyProps={{ className: mailTo }}
                />{' '}
                <Trans t={t} i18nKey="smtc.footer">
                    <Link to="/manual">User Manual</Link>
                    <Link to="/terms-of-use">Terms of Use</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/disclaimer">Disclaimer</Link>
                </Trans>
            </div>
        </footer>
    )
}

export default Footer
